
import React, {useEffect, useState} from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from '@material-ui/core';
import {useGoVehisService} from "../../utils/axios";

const AkolDealerNoteDialog = ({isOpen = false, onClose, dealerNip = null, initialNote = '', onSave}) => {
  const goVehisService = useGoVehisService();
  const [noteText, setNoteText] = useState('');

  useEffect(() => {
    if (isOpen) {
      setNoteText(initialNote || '');
    } else {
      setNoteText('');
    }
  }, [isOpen, initialNote]);

  const handleSaveNote = async () => {
    try {
      await goVehisService.post(`/admin/akol/dealers/${dealerNip}/note`, noteText, {
        headers: {
          "Content-Type": "text/plain; charset=utf-8",
        }
      });
      
      if (onSave) {
        onSave();
      }
      onClose();
    } catch (error) {
      console.error('Error saving note:', error);
    }
  };

  const handleClose = () => {
    setNoteText('');
    onClose();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="note-dialog-title" open={isOpen}>
      <DialogTitle id="note-dialog-title">
        Notatka
      </DialogTitle>
      <DialogContent dividers style={{minWidth: '400px'}}>
        <TextField
          fullWidth
          multiline
          rows={6}
          variant="outlined"
          placeholder="Wprowadź notatkę..."
          value={noteText}
          onChange={(e) => setNoteText(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Anuluj
        </Button>
        <Button onClick={handleSaveNote} color="primary" variant="contained">
          Zapisz
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AkolDealerNoteDialog;
